import React from 'react';
import PropTypes from 'prop-types';

const PlusIcon = ({ className }) => {
    return (

       
        <svg
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="currentColor" 
            className={`fill-current ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.87354 8C3.87354 7.72386 4.08807 7.5 4.3527 7.5H12.0194C12.284 7.5 12.4985 7.72386 12.4985 8C12.4985 8.27614 12.284 8.5 12.0194 8.5H4.3527C4.08807 8.5 3.87354 8.27614 3.87354 8Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.1862 3.5C8.45083 3.5 8.66536 3.72386 8.66536 4V12C8.66536 12.2761 8.45083 12.5 8.1862 12.5C7.92156 12.5 7.70703 12.2761 7.70703 12V4C7.70703 3.72386 7.92156 3.5 8.1862 3.5Z" fill="currentColor"/>
        </svg>
        

    );
};

PlusIcon.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

PlusIcon.defaultProps = {
    className: '', // Default to an empty string
};

export default PlusIcon;